export default "__VITE_ASSET__BG9cHk2G__"